import { IButtonProps } from "@atoms/ZButton/interface";
import { ArgsProps } from "antd/lib/message";
import { AxiosError } from "axios";

export enum ExceptionType {
	CfAuthorizationException = "cf_authorization_exception",
	InvalidMergeTagTypeException = "invalid_merge_tag_exception",
	UnexpectedDatabaseException = "unexpected_database_exception",
	CompanyNotFoundException = "company_not_found_exception",
	UserNotFoundException = "user_not_found_exception",
	PipelineException = "pipeline_exception",
	BadParamsQueryBuilderException = "bad_params_query_builder_exception",
	UniquenessConstraintException = "uniqueness_constraint_exception",
	DryRunException = "dry_run_exception",
	EntityNotFoundException = "entity_not_found_exception",
	ValidationException = "validation_exception",
	UnsafePutRequestException = "unsafe_put_request_exception",
	BadRequestException = "bad_request_exception",
	InternalServerException = "internal_server_exception",
	AuthSupportException = "auth_support_exception",
	ExpiredTokenException = "expired_Token_exception",
	ReAuthorizeException = "re_authorize_exception",
	AccessException = "access_exception",
	IntegrationException = "integration_exception",
	ServiceUnavailableException = "service_unavailable_exception",
	PdfGenerationException = "pdf_generation_exception",
	InsufficientRuleException = "insufficient_balance",
	ConflictException = "conflict_exception"
}

export interface ChildException {
	statusCode: number;
	description: string;
	exception_type: ExceptionType;
}
export interface ServerValidationErrorResponse {
	description: string;
	message: string;
	code: number;
	stacktrace?: string;
	child_exceptions: ChildException[];
}

export interface ServerErrorProps {
	readonly errorData: AxiosError<ServerValidationErrorResponse>;
	readonly reportData: any;
	readonly currentLocationPath: string;
}

export enum messageType {
	SUCCESS = "success",
	ERROR = "error",
	WARN = "warn",
	INFO = "info"
}
export interface ContentProps {
	readonly content: React.ReactNode;
	readonly type?: messageType;
	readonly "data-testid"?: string;
	readonly className?: string;
	readonly onClose?: () => void;
	readonly onClick?: () => void;
	readonly uniqueKey: string;
}

export enum ErrorType {
	ERROR = 0,
	SUCCESS = 200,
	ERROR_HELP = 400,
	ERROR_REPORT = 500
}

export interface FreshDeskTicketDescription {
	error_details?: ServerValidationErrorResponse;
	curl: string;
	stacktrace?: string;
	context: {
		userId: string;
		companyId: string;
		userDescription: string;
		opportunity: any; // keeping it as any to avoid importing contracts
		report: any; // keeping it as any to avoid importing contracts
		pipeline: any; // keeping it as any to avoid importing contracts
		client: any; // keeping it as any to avoid importing contracts
		/**
		 * @improvement:
		 *
		 * make `extra` prop and have as any
		 *
		 * This might affect data viewing so not doing right now
		 */
	};
	technographics: {
		OSName: string;
		browserName: string;
		fullVersion: string;
		majorVersion: number;
		appName: string;
		userAgent: string;
	};
}

export type ConfigContent = React.ReactNode | string;
export type JointContent = ConfigContent | ArgsProps;

export interface INeedHelpButtonProps {
	errorDetails: string;
	isBackendError?: boolean;
	apiUrl?: string;
	location: string;
}

export interface ISuccessButtonProps {
	readonly buttonText: string;
	readonly buttonProps: IButtonProps;
}
